/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_SubtitleInputs */

const en_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drills and tips to work on between lessons.`)
};

const es_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicios y consejos para practicar entre lecciones.`)
};

const de_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungen und Tipps, an denen Sie zwischen den Unterrichtsstunden arbeiten können.`)
};

const zh_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课间练习和技巧。`)
};

const ar_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمارين ونصائح للعمل عليها بين الدروس.`)
};

const fr_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices et astuces à travailler entre les cours.`)
};

const vi_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài tập và mẹo để luyện giữa các buổi học.`)
};

const sw_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mazoezi na vidokezo vya kufanyia kazi kati ya masomo.`)
};

const th_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แบบฝึกและเคล็ดลับสำหรับฝึกระหว่างบทเรียน`)
};

const bs_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vježbe i savjeti za rad između lekcija.`)
};

const ja_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンの合間に取り組めるドリルとヒント。`)
};

const ko_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 사이에 연습할 드릴과 팁.`)
};

const pt_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios e dicas para trabalhar entre as aulas.`)
};

const it_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizi e consigli su cui lavorare tra una lezione e l'altra.`)
};

const sv_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Övningar och tips att arbeta med mellan lektionerna.`)
};

const nl_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefeningen en tips om tussen de lessen aan te werken.`)
};

const da_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Øvelser og tips, du kan arbejde med mellem lektionerne.`)
};

const nb_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Øvelser og tips du kan jobbe med mellom timene.`)
};

const fi_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoitteita ja vinkkejä tuntien väliin.`)
};

const pl_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ćwiczenia i wskazówki do pracy między lekcjami.`)
};

const ru_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упражнения и советы для работы между уроками.`)
};

const tr_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dersler arasında üzerinde çalışılacak alıştırmalar ve ipuçları.`)
};

const hi_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठों के बीच अभ्यास के लिए ड्रिल और सुझाव।`)
};

const id_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latihan dan tips untuk dilatih di sela pelajaran.`)
};

const ms_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latih tubi dan petua untuk diusahakan di antara pelajaran.`)
};

const cs_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cvičení a tipy na procvičování mezi lekcemi.`)
};

const el_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ασκήσεις και συμβουλές για να δουλέψετε ανάμεσα στα μαθήματα.`)
};

const he_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תרגילים וטיפים לעבוד עליהם בין השיעורים.`)
};

const af_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefeninge en wenke om tussen lesse aan te werk.`)
};

const hu_practice_subtitle = /** @type {(inputs: Practice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyakorlatok és tippek az órák közötti gyakorláshoz.`)
};

/**
* | output |
* | --- |
* | "Drills and tips to work on between lessons." |
*
* @param {Practice_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_subtitle = /** @type {((inputs?: Practice_SubtitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_SubtitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_subtitle(inputs)
	if (locale === "de") return de_practice_subtitle(inputs)
	if (locale === "zh") return zh_practice_subtitle(inputs)
	if (locale === "ar") return ar_practice_subtitle(inputs)
	if (locale === "fr") return fr_practice_subtitle(inputs)
	if (locale === "vi") return vi_practice_subtitle(inputs)
	if (locale === "sw") return sw_practice_subtitle(inputs)
	if (locale === "th") return th_practice_subtitle(inputs)
	if (locale === "bs") return bs_practice_subtitle(inputs)
	if (locale === "ja") return ja_practice_subtitle(inputs)
	if (locale === "ko") return ko_practice_subtitle(inputs)
	if (locale === "pt") return pt_practice_subtitle(inputs)
	if (locale === "it") return it_practice_subtitle(inputs)
	if (locale === "sv") return sv_practice_subtitle(inputs)
	if (locale === "nl") return nl_practice_subtitle(inputs)
	if (locale === "da") return da_practice_subtitle(inputs)
	if (locale === "nb") return nb_practice_subtitle(inputs)
	if (locale === "fi") return fi_practice_subtitle(inputs)
	if (locale === "pl") return pl_practice_subtitle(inputs)
	if (locale === "ru") return ru_practice_subtitle(inputs)
	if (locale === "tr") return tr_practice_subtitle(inputs)
	if (locale === "hi") return hi_practice_subtitle(inputs)
	if (locale === "id") return id_practice_subtitle(inputs)
	if (locale === "ms") return ms_practice_subtitle(inputs)
	if (locale === "cs") return cs_practice_subtitle(inputs)
	if (locale === "el") return el_practice_subtitle(inputs)
	if (locale === "he") return he_practice_subtitle(inputs)
	if (locale === "af") return af_practice_subtitle(inputs)
	if (locale === "hu") return hu_practice_subtitle(inputs)
	return en_practice_subtitle(inputs)
});